<template>
  <button
    class="pdp-variant-selector-add-to-cart"
    :disabled="addToCartButtonDisabled"
    type="button"
    :class="[
      {
        'button-fill-no-hover': hasButtonStateProgress
      },
      {
        'button-fill-no-hover': hasButtonStateError
      }
    ]"
    @click="add()"
  >
    <div
      v-if="hasButtonStateProgress"
      :class="{ loader: hasButtonStateProgress }"
    />

    <div v-else-if="hasButtonStateSuccess" class="icon-check-mark">
      <IconCheckMark />
    </div>

    <div v-else-if="hasButtonStateError">
      <IconErrorCross />
    </div>

    <div v-else>
      {{ addToCartButtonText }}
    </div>
  </button>
</template>

<script>
import * as ShopifyCurrency from '@shopify/theme-currency';
import addToCartMixin from '../../mixins/addToCartMixin';

import IconCheckMark from '../assets/icon-check-mark.svg?inline';
import IconErrorCross from '../assets/icon-error-cross.svg?inline';

export default {
  components: {
    IconCheckMark,
    IconErrorCross
  },
  mixins: [addToCartMixin],
  props: {
    selectedVariant: {
      type: Object
    },
    translations: {
      type: Object
    },
    quantity: {
      type: Number
    },
    product: {
      type: Object
    },
    variantPrice: {
      type: Number
    },
    purchaseType: {
      type: String
    },
    deliveryInterval: {
      type: String
    },
    shippingIntervalUnitType: {
      type: String
    }
  },
  computed: {
    addToCartButtonDisabled() {
      return !this.selectedVariant || !this.hasInventory;
    },
    hasInventory() {
      return this.selectedVariant.available;
    },
    addToCartButtonText() {
      if (!this.selectedVariant && this.hasInventory) {
        return this.translations.select;
      }

      if (!this.hasInventory) {
        return this.translations.soldOut;
      }

      if (this.purchaseType === 'subscription') {
        return `${this.translations.subscribeText} - ${this.formattedPrice(
          this.variantPrice
        )}`;
      }

      return `${this.translations.addToCart} - ${this.formattedPrice(
        this.variantPrice
      )}`;
    },
    notificationTitle() {
      if (this.product.variants.length > 1) {
        return `${this.product.title} - ${this.selectedVariant.title}`;
      }
      return this.product.title;
    }
  },
  methods: {
    add() {
      let variantId = this.selectedVariant.id;
      let properties = {};

      if (this.purchaseType === 'subscription') {
        variantId = this.selectedVariant.subscriptionVariantId;
        properties = {
          shipping_interval_frequency: this.deliveryInterval,
          shipping_interval_unit_type: this.shippingIntervalUnitType
        };
      }

      this.addToCart(
        parseInt(variantId),
        this.quantity,
        properties,
        this.notificationTitle
      );
    },
    formattedPrice(price) {
      return ShopifyCurrency.formatMoney(
        this.quantity * price,
        this.moneyFormat
      );
    }
  }
};
</script>
